module.exports = __webpack_public_path__ + "static/media/neutral.59680731.svg";